import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setIncarnateModal, setLoginModal, setMenuSliderToggle, setMenuTocToggle, setMenuEditLeftToggle, setMenuEditLeftMode, setMenuEditRightToggle, setLayoutOrganizerToggle, setEditRightPanelMode, setNotesSliderToggle } from '../globalUiState';

export const useSetLoginModal = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setLoginModal(!!open)), [dispatch]);
};

export const useSetIncarnateModal = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setIncarnateModal(!!open)), [dispatch]);
};

export const useSetMenuSliderToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setMenuSliderToggle(!!open)), [dispatch]);
};

export const useSetMenuTocToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setMenuTocToggle(!!open)), [dispatch]);
};

export const useSetMenuEditLeftToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setMenuEditLeftToggle(!!open)), [dispatch]);
};

export const useSetMenuEditLeftMode = () => {
  const dispatch = useDispatch();
  return useCallback((mode) => dispatch(setMenuEditLeftMode(mode)), [dispatch]);
};

export const useSetMenuEditRightToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setMenuEditRightToggle(!!open)), [dispatch]);
};

export const useSetLayoutOrganizerToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setLayoutOrganizerToggle(!!open)), [dispatch]);
};

export const useSetEditRightPanelMode = () => {
  const dispatch = useDispatch();
  return useCallback((mode) => dispatch(setEditRightPanelMode(mode)), [dispatch]);
};

export const useSetNotesSliderToggle = () => {
  const dispatch = useDispatch();
  return useCallback((open) => dispatch(setNotesSliderToggle(!!open)), [dispatch]);
};

export const useGlobalUiActions = () => {
  const setLoginModalCb = useSetLoginModal();
  const setIncarnateModalCb = useSetIncarnateModal();
  const setMenuSliderToggleCb = useSetMenuSliderToggle();
  const setMenuTocToggleCb = useSetMenuTocToggle();
  const setMenuEditLeftToggleCb = useSetMenuEditLeftToggle();
  const setMenuEditRightToggleCb = useSetMenuEditRightToggle();
  const setNotesSliderToggleCb = useSetNotesSliderToggle();

  return {
    setLoginModal: setLoginModalCb,
    setIncarnateModal: setIncarnateModalCb,
    setMenuSliderToggle: setMenuSliderToggleCb,
    setMenuTocToggle: setMenuTocToggleCb,
    setMenuEditLeftToggle: setMenuEditLeftToggleCb,
    setMenuEditRightToggle: setMenuEditRightToggleCb,
    setNotesSliderToggle: setNotesSliderToggleCb,
  };
};

